import React, { useState, useEffect } from 'react'

//third party
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(BarElement, CategoryScale, LinearScale, ArcElement, Tooltip, Legend, ChartDataLabels);

// ** Reactstrap Imports
import {
    Row,
    Col,
    CardTitle,
    CardText,
    Form,
    Label,
    Input,
    Button
} from "reactstrap"
import toast, { Toaster } from 'react-hot-toast'
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import PieChart from '../CustomChart/PieChart'
import PieChartLegends from '../CustomChart/PieChartLegends'
//custom
import states from '../../../utility/State'
// Utility-Service
import { getToken, getUser } from '../../../utility/AuthService'
//API
import { getOverallDimensionStateData } from '../../../services/analyticsServices/overAllDimensionStateData';

const StateBasedAnalytics = (props) => {
    const token = getToken()
    const user = getUser()
    const [isLoading, setLoading] = useState(false)
    const [parcentOrDigit, setParcentOrDigit] = useState('digit')
    const [environmentData, setEnvironmentData] = useState([])
    const [environmentParcentVal, setEnvironmentParcentVal] = useState()
    const [socialData, setSocialData] = useState([])
    const [socialtParcentVal, setSocialParcentVal] = useState()
    const [governanceData, setGovernanceData] = useState([])
    const [governancetParcentVal, setGovernanceParcentVal] = useState()

    const dimensionLabelList = [
        {
            value: 'Leader',
            color: '#EC6258'
        },
        {
            value: 'Advanced',
            color: '#69BA6C'
        },
        {
            value: 'Beginner',
            color: '#FBC04F'
        },
        {
            value: 'Laggard',
            color: '#62AADF'
        },
        {
            value: 'Intermediate',
            color: '#ED61AE'
        },
    ];

    const {
        register,
        reset,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm();

    const watchSelectState = watch('state')

    /**
     * @function handleParcent
     * @param ()
     * @description to show data in parcent
     */
    const handleParcent = async () => {
        if (environmentData && socialData && governanceData) {
            setParcentOrDigit('parcent')
            const sumEnv = environmentData.reduce(function (a, b) {
                return a + b;
            });
            const parcentValEnv = environmentData.map(function (a) {
                return Math.floor((a / sumEnv) * 100);
            });
            setEnvironmentParcentVal(parcentValEnv)

            const sumSocial = socialData.reduce(function (a, b) {
                return a + b;
            });
            const parcentValSocial = socialData.map(function (a) {
                return Math.floor((a / sumSocial) * 100);
            });
            setSocialParcentVal(parcentValSocial)

            const sumGovernance = governanceData.reduce(function (a, b) {
                return a + b;
            });
            const parcentValGovernance = governanceData.map(function (a) {
                return Math.floor((a / sumGovernance) * 100);
            });
            setGovernanceParcentVal(parcentValGovernance)
        }

    };

    /**
     * @function handleDigit
     * @param ()
     * @description to show data in digit
     */
    const handleDigit = async () => {
        setParcentOrDigit('digit')
    }

    /**
     * @function getEnvironmentDataList
     * @param ()
     * @description to handle get environment data List
     */
    const getEnvironmentDataList = async () => {
        let result = []
        try {
            result = await getOverallDimensionStateData({
                authToken: token,
                id: props?.dimensionList?.find(item => item?.name === 'Environment')?._id,
                state: watchSelectState.label,
                userId: user?._id
            });
            if (result?.data?.statusCode === 200) {
                setLoading(false)
                setEnvironmentData(dimensionLabelList.map(item => result?.data?.data[item.value]))
            } else {
                setLoading(false);
                setEnvironmentData([])
                toast.error(result?.response?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            setLoading(false);
            setEnvironmentData([])
            toast.error(error?.response?.data?.message || 'Something went wrong!')
        }
    };

    /**
     * @function getSocialDataList
     * @param ()
     * @description to handle get social data List
     */
    const getSocialDataList = async () => {
        let result = []
        try {
            result = await getOverallDimensionStateData({
                authToken: token,
                id: props?.dimensionList?.find(item => item?.name === 'Social')?._id,
                state: watchSelectState.label,
                userId: user?._id
            });
            if (result?.data?.statusCode === 200) {
                setLoading(false)
                setSocialData(dimensionLabelList.map(item => result?.data?.data[item.value]))
            } else {
                setLoading(false);
                setSocialData([])
                toast.error(result?.response?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            setLoading(false);
            setSocialData([])
            toast.error(error?.response?.data?.message || 'Something went wrong!')
        }
    };

    /**
     * @function getGovernanceDataList
     * @param ()
     * @description to handle get social data List
     */
    const getGovernanceDataList = async () => {
        let result = []
        try {
            result = await getOverallDimensionStateData({
                authToken: token,
                id: props?.dimensionList?.find(item => item?.name === 'Governance')?._id,
                state: watchSelectState.label,
                userId: user?._id
            });
            if (result?.data?.statusCode === 200) {
                setLoading(false)
                setGovernanceData(dimensionLabelList.map(item => result?.data?.data[item.value]))
            } else {
                setLoading(false);
                setGovernanceData([])
                toast.error(result?.response?.data?.message || 'Something went wrong')
            }
        } catch (error) {
            setLoading(false);
            setGovernanceData([])
            toast.error(error?.response?.data?.message || 'Something went wrong!')
        }
    };

    useEffect(() => {
        if (props?.dimensionList?.length > 0 && watchSelectState) {
            getEnvironmentDataList()
            getSocialDataList()
            getGovernanceDataList()
        }
    }, [props?.dimensionList, watchSelectState]);

    const EnvironmentDimensionStateData = {
        labels: dimensionLabelList.map(item => item.value),
        datasets: [
            {
                data: parcentOrDigit === 'digit' ? environmentData : environmentParcentVal,
                backgroundColor: dimensionLabelList.map(item => item.color),
                borderColor: 'white',
                borderWidth: 2
            },
        ],
    };

    const SocialDimensionStateData = {
        labels: dimensionLabelList.map(item => item.value),
        datasets: [
            {
                data: parcentOrDigit === 'digit' ? socialData : socialtParcentVal,
                backgroundColor: dimensionLabelList.map(item => item.color),
                borderColor: 'white',
                borderWidth: 2
            },
        ],
    };

    const GovernanceDimensionStateData = {
        labels: dimensionLabelList.map(item => item.value),
        datasets: [
            {
                data: parcentOrDigit === 'digit' ? governanceData : governancetParcentVal,
                backgroundColor: dimensionLabelList.map(item => item.color),
                borderColor: 'white',
                borderWidth: 2
            },
        ],
    };

    const stateBasedChartOptions = {
        responsive: false,
        maintainAspectRatio: true,
        plugins: {
            legend: {
                display: false
            },
            datalabels: {
                formatter: (value, ctx) => {
                    let percentage = 0
                    percentage = parcentOrDigit === 'digit' ? `${value}` : `${value}%`;
                    // percentage = `${ctx.chart.data.labels[ctx.dataIndex]}\n${value}%`;
                    return percentage;
                },
                color: 'white',
                font: {
                    weight: 'bold',
                    size: 12
                }
            }
        }
    };

    return (
        <>
            {/* <div>
                <Toaster />
            </div> */}
            <div className='d-flex justify-content-between align-items-center py-2 flex-column flex-md-row'>
                <h4 className=''>State Based Data</h4>
                <div className='d-flex align-items-center rounded-pill bg-btn-analytics px-2 py-2'>
                    <Button color='' className={parcentOrDigit === 'parcent' ? 'bg-white rounded-pill text-primary' : 'bg-btn-analytics rounded-pill text-primary'} onClick={handleParcent}>
                        Percentage
                    </Button>
                    <Button color='' className={parcentOrDigit === 'digit' ? 'bg-white rounded-pill text-primary' : 'bg-btn-analytics rounded-pill text-primary'} onClick={handleDigit}>
                        Digit number
                    </Button>
                </div>

            </div>
            <Row className='border mb-5'>
                <div className='d-flex align-items-center mt-2'>
                    <label htmlFor="Location" className="form-label">
                        Location : &nbsp;
                    </label>
                    <Controller
                        name="state"
                        control={control}
                        render={({ field }) => (
                            <Select
                                className='w-40'
                                options={states}
                                {...field}
                            />
                        )}
                        rules={{ required: true }}
                    />

                    {errors.state && <div>Field is rquired</div>}

                </div>
                {environmentData && socialData && governanceData ? <Row className='d-flex flex-row justify-content-between px-5 py-2'>
                    <Col md={3} lg={3} sm={12} className='d-flex flex-column align-items-center'>
                        <h5 className='mb-2'>{props?.languageUse === 'English' ? props?.dimensionList[1]?.name : props?.dimensionList[1]?.name_Malay}</h5>
                        {environmentData?.every(item => item === 0) ? <>
                            <p className='my-5 text-danger'>No Data available</p>
                        </> : <>
                            <div className='d-flex flex-column  align-items-center'>
                                <PieChart options={stateBasedChartOptions} data={EnvironmentDimensionStateData} width={220} height={220} />
                            </div>
                        </>}
                    </Col>
                    <Col md={3} lg={3} sm={12} className='d-flex flex-column align-items-center'>
                        <h5 className='mb-2'>{props?.languageUse === 'English' ? props?.dimensionList[2]?.name : props?.dimensionList[2]?.name_Malay}</h5>
                        {socialData?.every(item => item === 0) ? <>
                            <p className='my-5 text-danger'>No Data available</p>
                        </> : <>
                            <div className='d-flex flex-column  align-items-center'>
                                <PieChart options={stateBasedChartOptions} data={SocialDimensionStateData} width={220} height={220} />
                            </div>
                        </>}
                    </Col>
                    <Col md={3} lg={3} sm={12} className='d-flex flex-column align-items-center'>
                        <h5 className='mb-2'>{props?.languageUse === 'English' ? props?.dimensionList[3]?.name : props?.dimensionList[3]?.name_Malay}</h5>
                        {governanceData?.every(item => item === 0) ? <>
                            <p className='my-5 text-danger'>No Data available</p>
                        </> : <>
                            <div className='d-flex flex-column  align-items-center'>
                                <PieChart options={stateBasedChartOptions} data={GovernanceDimensionStateData} width={220} height={220} />
                            </div>
                        </>}
                    </Col>
                </Row> : <div className='my-5 text-center text-primary fw-bold'>
                    <p>Select location first to see chart</p>
                </div>}

                <div>
                    <PieChartLegends />
                </div>
            </Row>
        </>
    )
};

export default StateBasedAnalytics